import React from 'react';
import { connect } from 'react-redux';
import "../styles/patientLookup.css";
import * as actions from "../actions/index";
import PatientSelectStep from "../components/PatientSelectStep.jsx";

const mapStateToProps = state => {
    return {
        patients: state.patients.patientsInfo,
        selected: state.patients.selected
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectPatient: (patient) => dispatch(actions.selectPatient(patient)),
        goBack: () => {
            dispatch(actions.setCurrentStep(1)); dispatch(actions.selectPatient(undefined))
        },
        goNext: () => dispatch(actions.setCurrentStep(3))
    }
};

const PatientSelectStepController = connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientSelectStep);

export default PatientSelectStepController;